// 平台端「淘客」整套管理页面搬到淘客后台。
//
// 本项目已有一套面向门店自己的 /distribution（淘客概况、我的淘客商……），
// 所以这套管理视角另起 /distribution-admin，目录 views/distributionAdmin，
// 路由 name 统一加 Admin 后缀，两套并存互不覆盖。
//
// 侧边栏仍由 eb_system_menu 驱动（type=10），只加路由菜单里不会出现，
// 菜单和授权见 tjmall/sql/distribution_admin_platform_menus.sql。

import Layout from '@/layout';
var distributionAdminRouter = {
  path: '/distribution-admin',
  component: Layout,
  redirect: '/distribution-admin/distributionconfig',
  name: 'DistributionAdmin',
  meta: {
    title: '淘客管理(平台)',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/distributionAdmin/index');
    },
    name: 'distributionIndexAdmin',
    meta: {
      title: '淘客管理',
      icon: ''
    }
  }, {
    path: 'distributionconfig',
    component: function component() {
      return import('@/views/distributionAdmin/config/index');
    },
    name: 'distributionConfigAdmin',
    meta: {
      title: '淘客配置',
      icon: ''
    }
  }, {
    // 产品分享菜单来自数据库，平台端必须注册同名路由，否则点击会进入 404。
    path: 'product-share',
    component: function component() {
      return import('@/views/distributionAdmin/product-share/ParentView');
    },
    name: 'productShareAdmin',
    meta: {
      title: '产品分享',
      icon: ''
    },
    children: [{
      path: 'distributor',
      component: function component() {
        return import('@/views/distributionAdmin/index');
      },
      name: 'productShareDistributorAdmin',
      meta: {
        title: '淘客商列表',
        icon: ''
      }
    }, {
      path: 'settings',
      component: function component() {
        return import('@/views/distributionAdmin/config/index');
      },
      name: 'productShareSettingsAdmin',
      meta: {
        title: '淘客设置',
        icon: ''
      }
    }, {
      path: 'withdraw',
      component: function component() {
        return import('@/views/distributionAdmin/product-share/withdraw/index');
      },
      name: 'productShareWithdrawAdmin',
      meta: {
        title: '淘客商提现',
        icon: ''
      }
    }, {
      path: 'makers',
      component: function component() {
        return import('@/views/distributionAdmin/product-share/makers/index');
      },
      name: 'productShareMakersAdmin',
      meta: {
        title: '创客',
        icon: ''
      }
    }, {
      path: 'maker-withdraw',
      component: function component() {
        return import('@/views/distributionAdmin/product-share/withdraw/index');
      },
      name: 'productShareMakerWithdrawAdmin',
      meta: {
        title: '创客提现申请',
        icon: ''
      }
    }]
  }, {
    // 门店管理。菜单从数据库下发（perms: platform:distribution:store:list），
    // 路由必须同名注册，否则点菜单会 404
    path: 'store',
    component: function component() {
      return import('@/views/distributionAdmin/store/index');
    },
    name: 'distributionStoreAdmin',
    meta: {
      title: '门店管理',
      icon: ''
    }
  }, {
    // 平台单淘客团队管理：规则、团队业绩和订单分布在同一页面内切换。
    path: 'team',
    component: function component() {
      return import('@/views/distributionAdmin/team/index');
    },
    name: 'distributionTeamAdmin',
    meta: {
      title: '团队管理',
      icon: ''
    }
  },
  // 校园收益联盟。接口在 tjMall-alliance，走网关 /alliance；挂在淘客路由下，不新开一级菜单
  {
    path: 'alliance/region',
    component: function component() {
      return import('@/views/distributionAdmin/alliance/region/index');
    },
    name: 'allianceRegionAgentAdmin',
    meta: {
      title: '区域与代理',
      icon: ''
    }
  }, {
    // 成为团长的条件。条件还没定下来，所以做成规则表而不是几个写死的配置项，
    // 运营自由增删改，不用等发版
    path: 'alliance/leader-apply-rule',
    component: function component() {
      return import('@/views/distributionAdmin/alliance/leader-apply-rule/index');
    },
    name: 'allianceLeaderApplyRuleAdmin',
    meta: {
      title: '团长申请条件',
      icon: ''
    }
  }, {
    path: 'alliance/leader',
    component: function component() {
      return import('@/views/distributionAdmin/alliance/leader/index');
    },
    name: 'allianceLeaderAdmin',
    meta: {
      title: '团长业绩',
      icon: ''
    }
  }, {
    // 平台端淘客商品总览：跨商户只读 + 强制停用。菜单是既有的 3151，
    // 它指向的旧「平台给商户配淘客」页删掉后一直是隐藏状态，这次按新用途重建
    path: 'alliance/distribution-product',
    component: function component() {
      return import('@/views/distributionAdmin/alliance/distribution-product/index');
    },
    name: 'allianceDistributionProductAdmin',
    meta: {
      title: '淘客商品',
      icon: ''
    }
  }, {
    // 分账账单：区域代理 / 团长两层汇总，是「分账明细」那张流水表的上层视图
    path: 'alliance/bill',
    component: function component() {
      return import('@/views/distributionAdmin/alliance/bill/index');
    },
    name: 'allianceBillAdmin',
    meta: {
      title: '分账账单',
      icon: ''
    }
  }, {
    path: 'alliance/commission',
    component: function component() {
      return import('@/views/distributionAdmin/alliance/commission/index');
    },
    name: 'allianceCommissionAdmin',
    meta: {
      title: '分账明细',
      icon: ''
    }
  }, {
    path: 'alliance/withdraw',
    component: function component() {
      return import('@/views/distributionAdmin/alliance/withdraw/index');
    },
    name: 'allianceWithdrawAdmin',
    meta: {
      title: '团长提现',
      icon: ''
    }
  }, {
    path: 'alliance/verify-limit',
    component: function component() {
      return import('@/views/distributionAdmin/alliance/verify-limit/index');
    },
    name: 'allianceVerifyLimitAdmin',
    meta: {
      title: '核销限额',
      icon: ''
    }
  }, {
    path: 'alliance/points',
    component: function component() {
      return import('@/views/distributionAdmin/alliance/points/index');
    },
    name: 'alliancePointsAdmin',
    meta: {
      title: '积分对账',
      icon: ''
    }
  }, {
    path: 'alliance/verify',
    component: function component() {
      return import('@/views/distributionAdmin/alliance/verify/index');
    },
    name: 'allianceVerifyRecordsAdmin',
    meta: {
      title: '核销记录',
      icon: ''
    }
  }, {
    path: 'alliance/risk',
    component: function component() {
      return import('@/views/distributionAdmin/alliance/risk/index');
    },
    name: 'allianceRiskAdmin',
    meta: {
      title: '联盟风控',
      icon: ''
    }
  }, {
    path: 'alliance/config',
    component: function component() {
      return import('@/views/distributionAdmin/alliance/config/index');
    },
    name: 'allianceConfigAdmin',
    meta: {
      title: '联盟配置',
      icon: ''
    }
  }]
};
export default distributionAdminRouter;